var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemoModeNavigatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.987mm",
    height: "26.013mm",
    viewBox: "0 0 25.987 26.013",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.11 .26491)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      strokeWidth: "1.58px",
      strokeLinecap: "round",
      stroke: "#4894ff",
      strokeOpacity: 0.54383767,
      fill: "rgb(255, 255, 255)"
    },
    points: "81.974 12.135 81.974 0.535 104.31 0.535 104.31 18.735 96.349 18.735 96.349 24.935 81.974 24.935 81.974 20.635"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.52917 0.57052v24.384l17.904-0.03036v-6.1923l6.4958-0.01102-0.01613-18.192z",
    fill: "#f9f9f9",
    stroke: "#707070",
    strokeWidth: 1.5875
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5875,
    transform: "matrix(1, 0, 0, 1, -2.060503, -0.141248)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.657583, 0, 0, 0.657583, 21.734819, 5.90217)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1
    },
    cx: 92.203,
    cy: 20.369,
    rx: 1.274,
    ry: 1.274
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1
    },
    cx: 97.203,
    cy: 20.369,
    rx: 1.274,
    ry: 1.274
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 1,
      fill: "rgb(2, 124, 189)",
      stroke: "rgb(2, 124, 189)"
    },
    cx: 94.76,
    cy: 22.962,
    rx: 2.469,
    ry: 2.469
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 83.93 2.603 L 102.399 2.559 L 102.379 5.069 L 83.903 5.069 L 83.903 7.738 L 102.38 7.738 L 102.38 10.349 L 83.866 10.349 L 83.866 12.976 L 95.759 12.976",
    fill: "none",
    stroke: "#6FCF89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.5712,
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoModeNavigatorIcon);
export default __webpack_public_path__ + "static/media/DemoModeNavigatorIcon.05870c92c72d7d9cd0a8b22dea3a0970.svg";
export { ForwardRef as ReactComponent };